import { useState } from 'react'
import { Link } from 'react-router-dom'
import { BotMessageSquare, Menu } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet'
import useChatStore from '@/stores/useChatStore'
import { UserNav } from './UserNav'
import { MainNav } from './MainNav'

export const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const startNewSession = useChatStore((state) => state.startNewSession)

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 max-w-screen-2xl items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2"
          onClick={startNewSession}
        >
          <BotMessageSquare className="h-6 w-6 text-primary" />
          <span className="font-bold text-lg">Assistant API</span>
        </Link>

        <nav className="hidden md:flex items-center gap-6 text-sm font-medium">
          <MainNav />
        </nav>

        <div className="flex items-center gap-4">
          <UserNav />

          <div className="md:hidden">
            <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon">
                  <Menu className="h-5 w-5" />
                  <span className="sr-only">Open menu</span>
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[240px]">
                <div className="flex flex-col gap-4 py-6 text-lg font-medium">
                  <MainNav onLinkClick={() => setIsMobileMenuOpen(false)} />
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  )
}
